import { compareHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';

import { MappedBudget } from '../../../../hooks/useBudgets';

export const budgetComparator = compareHelpers.combineComparators<MappedBudget>(
    (a, b) => {
        if (a.origin !== domain.BudgetOrigin.Manual) {
            if (b.origin !== domain.BudgetOrigin.Manual) {
                return 0;
            }

            return -1;
        }

        if (b.origin === domain.BudgetOrigin.Manual) {
            return 0;
        }

        return 1;
    },
    compareHelpers.comparatorFor<MappedBudget>(compareHelpers.stringComparator2Asc, 'name')
);
